(function () {
    'use strict';

    var module = angular.module('uwAgenda.search');
    module.directive('searchAppointment', ['AppointmentDetailService', SearchAppointmentFn]);

    /* directive for appointment in search-result */
    function SearchAppointmentFn(AppointmentDetailService) {

        var directive = {
            restrict: 'E',
            templateUrl: '/app/search/templates/search-appointment.template.html',
            scope: {
                appointment: '=',
                searchStr: '='
            },
            link: link
        };
        return directive;

        function link(scope) {
            scope.open = function () {
                AppointmentDetailService.show(scope.appointment.id);
            };
        }
    }
})();